var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVentilation = function SvgVentilation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4",
    width: 32,
    height: 32,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path848",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.657,
    d: "M16.004 20.493c2.478 0 4.498-2.02 4.498-4.496s-2.02-4.496-4.498-4.496-4.512 2.02-4.512 4.496 2.035 4.496 4.512 4.496z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path850",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.45,
    d: "M10.398 16.094C4.308 16.91-.813 11.432 2.523 5.11c.747-1.397 2.519-3.334 4.705-3.79 2.755-.416 4.776.608 5.357 2.96.194 1.217-.083 2.13-.83 3.362-1.136 1.854-.264 2.877.871 3.846"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path852",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.45,
    d: "M15.962 10.671c-.955-6.06 4.401-11.302 10.81-8.107 1.412.706 3.391 2.435 3.903 4.607.47 2.739-.512 4.786-2.851 5.409-1.218.221-2.132-.028-3.391-.747-1.869-1.093-2.879-.208-3.806.955"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path854",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.45,
    d: "M21.637 15.928c6.076-.816 11.197 4.662 7.862 10.984-.734 1.397-2.52 3.334-4.706 3.79-2.755.416-4.775-.608-5.343-2.96-.194-1.217.07-2.13.83-3.362 1.122-1.853.264-2.877-.871-3.846"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path856",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.45,
    d: "M16.059 21.351c.955 6.06-4.401 11.302-10.796 8.107-1.412-.706-3.391-2.435-3.903-4.62-.485-2.74.512-4.774 2.851-5.396 1.204-.221 2.118.014 3.377.747 1.869 1.093 2.88.207 3.82-.955"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVentilation);
export default ForwardRef;